import React, { useState, useEffect, useRef } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";
import { ResourceRequester } from "sulu-admin-bundle/services";
import { CircularProgress } from "@mui/material";

export default function LocationSelect({ match, onChange }) {
    const { t } = useTranslation();
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [value, setValue] = useState(
        match?.locationID && match?.location
            ? { id: match.locationID, locationName: match.location }
            : null
    );
    const [inputValue, setInputValue] = useState(match?.location || "");

    const debounceTimeout = useRef(null);

    const handleInputChange = (event, newInputValue) => {
        setInputValue(newInputValue);

        if (newInputValue.length < 3) {
            setOptions([]);
            return;
        }

        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }

        debounceTimeout.current = setTimeout(async () => {
            setLoading(true);
            try {
                const response = await ResourceRequester.getList("venue", {
                    search: newInputValue,
                    fields: "locationName,id",
                    limit: 10,
                });

                const venues = response?._embedded?.venue || [];

                setOptions(venues);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        }, 500);
    };

    return (
        <Autocomplete
            value={value}
            inputValue={inputValue}
            onInputChange={handleInputChange}
            options={options}
            onChange={(event, newValue) => {
                setValue(newValue);
                onChange?.(newValue);
            }}
            loading={loading}
            getOptionLabel={(option) => {
                if (typeof option === "string") return option;
                if (
                    option &&
                    typeof option === "object" &&
                    option.locationName
                ) {
                    return option.locationName;
                }
                return "";
            }}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={t("gamedays.match.locations_label")}
                    variant="outlined"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? (
                                    <CircularProgress
                                        color="inherit"
                                        size={20}
                                    />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
        />
    );
}
